import React from 'react';

import {
  ContentGroup,
  Heading,
  Link,
  List,
  ListItem,
  Main,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import Helmet from 'react-helmet';

import { LandlordAssociationsContent } from './LandlordAssociationsPage.config';
import * as routes from '../manifest';

function LandlordAssociationsPage() {
  const {
    metaContent,
    backLabel,
    title,
    the,
    englandAndWales,
    scotland,
    northernIreland,
  } = useContent<LandlordAssociationsContent>();
  return (
    <Main>
      <Helmet>
        <title>{metaContent.title}</title>
      </Helmet>
      <ContentGroup marginTop="05" marginBottom="none">
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={routes.LandlordSupport}
        >
          {backLabel}
        </StyledLink>
      </ContentGroup>
      <Heading as="h1" size="s7" marginTop="05">
        {title}
      </Heading>
      <Heading as="h2">{englandAndWales.title}</Heading>
      <List>
        <ListItem>
          {the}
          <Link href={englandAndWales.nationalResidentialLinkHref} external>
            {englandAndWales.nationalResidentialLinkLabel}
          </Link>
          {englandAndWales.isTheLargest}
        </ListItem>
        <ListItem>
          {the}
          <Link href={englandAndWales.britishLandlordsLinkHref} external>
            {englandAndWales.britishLandlordsLinkLabel}
          </Link>
          {englandAndWales.isANational}
        </ListItem>
      </List>

      <Heading as="h2">{scotland.title}</Heading>
      <List>
        <ListItem>
          {the}
          <Link href={scotland.scottishAssociationLinkHref} external>
            {scotland.scottishAssociationLinkLabel}
          </Link>
          {scotland.offersPracticalHelp}
        </ListItem>
      </List>

      <Heading as="h2">{northernIreland.title}</Heading>
      <List>
        <ListItem>
          {the}
          <Link href={northernIreland.landlordsAssocationLinkHref} external>
            {northernIreland.landlordsAssocationLinkLabel}
          </Link>
          {northernIreland.representsTheInterests}
        </ListItem>
      </List>
      <Paragraph>{northernIreland.canAlsoCheck}</Paragraph>
    </Main>
  );
}

export default LandlordAssociationsPage;
